package com.anjuros.website.redesign.sections.portal

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdClosingCard
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText

@Composable
fun PortalClosingSection() {
    RdClosingCard(
        RdText.PORTAL_CLOSE_EYEBROW, RdText.PORTAL_CLOSE_TITLE, RdText.PORTAL_CLOSE_LEDE,
        secondaryText = RdText.CTA_SEE_ALL_DESIGNS, secondaryPath = RdRoute.DESIGNS,
    )
}
